module.exports = __webpack_public_path__ + "static/media/Mouser-Selected.cc11b037.png";